import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'paymentCustomers',
  urlRoot: '/payment_customers'
})
